// animations.js — shared MUI keyframes.
import { keyframes } from "@mui/material";

export const float1 = keyframes`
  0%   { transform: translate(0px, 0px) scale(1); }
  50%  { transform: translate(60px, -40px) scale(1.1); }
  100% { transform: translate(0px, 0px) scale(1); }
`;

export const float2 = keyframes`
  0%   { transform: translate(0px, 0px) scale(1); }
  50%  { transform: translate(-50px, 50px) scale(1.05); }
  100% { transform: translate(0px, 0px) scale(1); }
`;

// Staggered cell entry. Each cell applies this with its own delay so the
// heatmap paints itself row-by-row instead of slapping onto the screen.
export const fadeInCell = keyframes`
  0%   { opacity: 0; transform: scale(0.85); }
  100% { opacity: 1; transform: scale(1); }
`;

// Skeleton shimmer for the loading grid.
export const shimmer = keyframes`
  0%   { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;
